import React from 'react';
import { TextField, FormHelperText } from '@mui/material';

const TimeSelector = ({
  value,
  onChange,
  label,
  disabled = false,
  fullWidth = true,
  error = false,
  helperText = '',
  size = 'medium'
}) => {
  // Ensure value is in HH:mm for native time input (strip seconds if present)
  const normalizedValue = value ? value.slice(0, 5) : '';

  return (
    <>
      <TextField
        fullWidth={fullWidth}
        disabled={disabled}
        error={error}
        label={label}
        type="time"
        size={size}
        value={normalizedValue}
        onChange={(e) => onChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        inputProps={{
          step: 60,
          min: '00:00',
          max: '23:59'
        }}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </>
  );
};

export default TimeSelector;
